import { HolidaySlot, WorkTimeSlot } from "modules/calendar-worktime-holiday";
import { isSameDate } from "./calender";

export const formatDate = (date: Date | string | null) => {
    if (!date) return "";
    const parsedDate = new Date(date);
    const options: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
        year: 'numeric'
    };
    return new Intl.DateTimeFormat('de-DE', options).format(parsedDate);
};

export const formatDaterec = (date: Date): string => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}.${month}.${year}`;
};

export const addDays = (date: Date, days: number) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
};
export const addWeeks = (date: Date, weeks: number) => {
    const result = new Date(date);
    result.setDate(result.getDate() + weeks * 7);
    return result;
};

export const getSlotsInDate = (date: Date, timeSlots: WorkTimeSlot[], holidays: HolidaySlot[]) => {

    const holidayInDate = holidays.filter((holiday) => {
        const holidayDate = holiday.date instanceof Date ? holiday.date : new Date(holiday.date);
        return isSameDate(date, holidayDate);
    });

    if (!holidayInDate.some((holiday) => holiday.is_full_day)) {
        const dayIndex = date.getDay();
        const daysOfWeek = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
        const selectedDay = daysOfWeek[dayIndex];

        const availableBlocks = timeSlots.filter((slot) =>
            slot.day_of_week === selectedDay &&
            !holidayInDate.some((holiday) => holiday.block === slot.id)
        );
        return availableBlocks;
    } else {
        return [];
    }
};


export const profileStatusLabels: { [key: string]: string } = {
  student: "Studierende Elternteil",
  university_staff: "Mitarbeiter:in der Universität Siegen",
  studierendenwerk_staff: "Mitarbeiter:in des Studierendenwerks Siegen",
  professor: "Professor:in",
  other: "Dritte",
};

export const customSelectStyles = {
    control: (base: any, state: any) => ({
        width: '100%',
        border: '1.5px solid',
        borderColor: state.isFocused ? '#3b3b3b' : '#707070',
        borderRadius: '10px',
        fontSize: window.innerWidth < 450 ? '12px' : '14px',
        backgroundColor: '#fff',
        boxShadow: 'none',
        display: 'flex',
        transition: 'border-color 0.2s ease',
    }),

    placeholder: (base: any) => ({
        ...base,
        color: '#000',
        display: 'flex',
        fontSize: window.innerWidth < 450 ? '12px' : '14px',
    }),

    singleValue: (base: any) => ({
        ...base,
        color: '#000',
        display: 'flex',
    }),

    option: (base: any, state: any) => ({
        ...base,
        backgroundColor: state.isSelected
            ? '#707070'
            : state.isFocused
                ? '#f0f0f0'
                : '#fff',
        color: state.isSelected ? '#fff' : '#333',
        padding: '10px',
        '&:active': {
            backgroundColor: '#e2e2e2',
        },
    }),

    dropdownIndicator: (base: any, state: any) => ({
        ...base,
        color: state.isFocused ? '#000' : '#707070',
        '&:hover': {
            color: '#000',
        },
    }),
};


